export function getLastPartOfUrl() {
    var currentUrl = window.location.href;
    var parts = currentUrl.split("/");
    var lastPart = parts.length > 1 ? parts[parts.length - 1] : null;
    return lastPart;
}
export function isNotEmpty(value: any) {
    return value !== undefined && value !== null && value !== '';
}

export function stringFormat(template: any, ...values: any) {
    return template.replace(/{(\d+)}/g, (match: any, index: number) => {
        return values[index] !== undefined ? values[index] : match;
    });
}